import { render, staticRenderFns } from "./ScrollBothSideTable.vue?vue&type=template&id=3d3b0634"
import script from "./ScrollBothSideTable.vue?vue&type=script&lang=js"
export * from "./ScrollBothSideTable.vue?vue&type=script&lang=js"
import style0 from "./ScrollBothSideTable.vue?vue&type=style&index=0&id=3d3b0634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports